import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import mixpanel from "mixpanel-browser";
import constants from "../constants";
import getEnv from "../getEnv";
import isMobile from "../isMobile";
var storeMixpanelEvents = function storeMixpanelEvents(name) {
  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var events = localStorage.getItem(constants.PERSISTED.mixpanelEvents) || "[]";
  var MIXPANEL_TOKEN = getEnv("NEXT_PUBLIC_MIXPANEL_TOKEN");
  if (events && MIXPANEL_TOKEN) {
    var eventsArray = JSON.parse(events);
    var _event = {
      name: name,
      properties: _objectSpread(_objectSpread({}, properties), {}, {
        timestamp: new Date().toISOString()
      })
    };
    eventsArray.push(_event);
    localStorage.setItem(constants.PERSISTED.mixpanelEvents, JSON.stringify(eventsArray));
  }
};
var syncMixpanelEvents = function syncMixpanelEvents() {
  var events = localStorage.getItem(constants.PERSISTED.mixpanelEvents);
  var MIXPANEL_TOKEN = getEnv("NEXT_PUBLIC_MIXPANEL_TOKEN");
  if (events && MIXPANEL_TOKEN) {
    var eventsArray = JSON.parse(events);
    eventsArray.forEach(function (event) {
      mixpanel.track(event.name, _objectSpread({
        deviceType: isMobile() ? "mobile" : "desktop"
      }, event.properties));
    });
    localStorage.removeItem(constants.PERSISTED.mixpanelEvents);
  }
};
export { storeMixpanelEvents, syncMixpanelEvents };